/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { StoreType } from './connect';

const staticHeader = 'width=1000, maximum-scale=1';
const responsiveHeader = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';

export const Breakpoint = {
  mPortrait: 0,
  mLandscape: 480,
  tPortrait: 720,
  tLandscape: 960,
  dRegular: 1200,
  dWide: 1440,
};

export function getResponsiveBreakpoint() {
  if (!BROWSER) {
    return Breakpoint.dWide;
  }

  const width = getClientWidth();
  if (width < Breakpoint.mLandscape) {
    return Breakpoint.mPortrait;
  }
  if (width < Breakpoint.tPortrait) {
    return Breakpoint.mLandscape;
  }
  if (width < Breakpoint.tLandscape) {
    return Breakpoint.tPortrait;
  }
  if (width < Breakpoint.dRegular) {
    return Breakpoint.tLandscape;
  }
  if (width < Breakpoint.dWide) {
    return Breakpoint.dRegular;
  }
  return Breakpoint.dWide;
}

export function isMobile(app: StoreType['app']): boolean {
  return (app as any)?.inReactNative || getResponsiveBreakpoint() === Breakpoint.mPortrait;
}

export function resizeCallback(mobileModeEnabled: boolean, isHd: boolean, forceFlip?: boolean) {
  if (isHd) {
    if (!document.body.classList.contains('Body-hd')) {
      document.body.classList.add('Body-hd');
    }
  } else {
    if (document.body.classList.contains('Body-hd')) {
      document.body.classList.remove('Body-hd');
    }
  }

  const metas = document.getElementsByTagName('meta');

  _.forEach(metas, (h) => {
    if (h.name !== 'viewport') {
      return;
    }

    let mobileEnabled = mobileModeEnabled;
    if (forceFlip) {
      //state hasn't had time to be set yet, so force the flip
      mobileEnabled = !mobileEnabled;
    }
    if (mobileEnabled) {
      h.content = responsiveHeader;
    } else {
      h.content = staticHeader;
    }
  });
}

export function getClientWidth() {
  return window.innerWidth || document?.documentElement?.clientWidth || document.body.clientWidth;
}
